import { EditProfileForm } from '@/modules/profile/components/EditProfileForm/EditProfileForm'
import { Main } from '@/modules/profile/components/Main/Main'

export function Component() {
  return (
    <Main header="Profile">
      <EditProfileForm />
    </Main>
  )
}

Component.displayName = 'Profile'
